module.exports = __webpack_public_path__ + "static/media/BoxPlotQ6_5.bb2b07a2.svg";